export const defaultTitle ="FrameGrinder | The online Warframe item database" 